export default "__VITE_ASSET__BTInmvOD__"